import React from 'react';
import { Provider } from 'react-redux';
// eslint-disable-next-line no-restricted-imports
import { defaultStore } from 'app/gamma/src/defaultStore';

export const ReduxProvider: React.FunctionComponent = ({ children }) => (
  <Provider store={defaultStore}>{children}</Provider>
);
